import React from "react"
import {
  footer,
  footerNewsletter,
  footerLinks,
  footerContact,
  goToHead,
  footerBottom,
  footerContent,
  footerInfo,
} from "./footer.module.scss"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"
import ContenuLibre from "gatsby-theme-blank/src/components/ContenuLibre/contenu-libre"
import InscriptionNewsletter from "gatsby-theme-blank/src/components/InscriptionNewsletter/inscriptionNewsletter"
import { useContenuLibre } from "gatsby-theme-blank/src/components/ContenuLibre/contenu-libre-query"
import {
  StyledFooter,
  GoToHead,
  FooterBottom,
  ColoredParagraph,
  FooterInfo,
} from "./footer-styled"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import { useFooter } from "gatsby-theme-blank/src/components/Layout/Footer/footer-query"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import { goToTop } from "react-scrollable-anchor"
import Obfuscate from "react-obfuscate"

//-----------------------Footer component---------------------------//
const Footer = () => {
  const data = useFooter()
  const dataContact = useBuildData().mentions_settings
  const accessibility = useBuildData().site_settings.accessibility
  const footerMenuData = data.allMenuLinkContentMenuLinkContent?.edges
  const hasFooterInfo = useContenuLibre().allNodeContenuLibre.edges.find(
    (element) =>
      element.node.relationships?.field_taxonomie_zone_libre?.name ===
      "zone_bas_page_accueil"
  )
  return (
    <>
      <StyledFooter className={footer} role="contentinfo" id="footer">
        <div className={footerContent}>
          {footerMenuData?.length > 0 && (
            <div className={footerLinks}>
              <ul>
                {footerMenuData.map((link) => (
                  <li key={link.node.title}>
                    <TransitionFade link={link.node.link.uri}>
                      {link.node.title}
                    </TransitionFade>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <div className={footerNewsletter}>
            <InscriptionNewsletter hasBorderRight={false} />
          </div>
          <FooterInfo className={footerInfo}>
            <ContenuLibre
              isIndex={true}
              zoneTaxoLibre="zone_bas_page_accueil"
            />
          </FooterInfo>
          {!hasFooterInfo && (
            <div className={footerContact}>
              <h2>Nous contacter</h2>
              <ColoredParagraph>
                <Icon size={26} icon="location2"></Icon>
                {dataContact.adress_social_name}
              </ColoredParagraph>
              <ColoredParagraph>
                <Icon size={26} icon="phone"></Icon>
                <Obfuscate tel={dataContact.phone_number} element="span" />
              </ColoredParagraph>
              <ColoredParagraph>
                <Icon size={26} icon="mail"></Icon>
                <Obfuscate email={dataContact.mail_adress} element="span" />
              </ColoredParagraph>
            </div>
          )}
          <GoToHead
            aria-label="Retour en haut de page"
            onClick={() => goToTop()}
            className={goToHead}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                goToTop()
              }
            }}
            role="button"
            tabIndex="0"
          >
            <Icon size={65} icon="circle-up"></Icon>
          </GoToHead>
        </div>
        <FooterBottom className={footerBottom}>
          <li>
            <TransitionFade link="/plan-site">Plan du site</TransitionFade>
          </li>
          <li>
            <a href="/rgpd" target="_blank">
              Règlement général sur la protection des données
            </a>
          </li>
          <li>
            <TransitionFade link="/mentions-legales">
              Mentions Légales
            </TransitionFade>
          </li>
          <li>
            <TransitionFade link="/mentions-legales#accessibilite">
              {accessibility ?? "Accessibilité"}
            </TransitionFade>
          </li>
        </FooterBottom>
      </StyledFooter>
    </>
  )
}
//-----------------------Footer component---------------------------//

export default Footer
